import React from 'react';

import { Messages } from '../../codegen/Localize';
import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { ContentDraftStatus } from '../serverApi/types/ContentDraft';
import { DraftStyles } from '../styles/DraftStyles';
import { DraftTagsParentType, DraftTagType } from '../types/DraftsTypes';
import { DraftTag } from './DraftTag';

export interface DraftTagsProps {
  readonly draftStatus: string;
  readonly explorableItemType?: ExplorableItemType; //used for tag's tooltip message
  readonly parentType?: DraftTagsParentType;  // determines tags container css style
}

export interface DraftInfo {
  message: string;
  type: DraftTagType;
}

export class DraftTags extends React.Component<DraftTagsProps>{
  private createTags(): DraftInfo[] {
    let draftInfo: DraftInfo[] = [];
    switch (this.props.draftStatus) {
      case ContentDraftStatus.unpublishedchanges:  //changes to existing workbook
        draftInfo.push({
          message: Messages.draftTag(),
          type: !this.props.parentType ? DraftTagType.staticTag : DraftTagType.unpublished
        });
        break;
      case ContentDraftStatus.unpublished:  //never published
        draftInfo.push(
          {
            message: Messages.draftTag(),
            type: DraftTagType.neverPublished
          },
          {
            message: Messages.draftUnpublishedTag(),
            type: DraftTagType.neverPublished
          });
        break;
      default:
        break;
    }
    return draftInfo;
  }

  private containerStyle(): string {
    switch (this.props.parentType) {
      case DraftTagsParentType.list:
        return DraftStyles.ListViewContainer;
      case DraftTagsParentType.card:
        return DraftStyles.DraftTagsCardContainer;
      default:
        return;
    }
  }

  public render() {
    let draftsInfo: DraftInfo[] = this.createTags();
    let draftTagFragments = draftsInfo.map((draftTag: DraftInfo, draftIndex: number) => {
      return (
        <React.Fragment key={`draft-tag-${draftIndex}`}>
          <DraftTag
            draftTag={draftTag.message}
            tagType={draftTag.type}
            explorableItemType={this.props.explorableItemType}
          > </DraftTag>
        </React.Fragment>
      );
    });
    return (
      <div className={this.containerStyle()}>
        {...draftTagFragments}
      </div>
    );
  }
}
